module.exports = __webpack_public_path__ + "static/media/blue-jeans.5d6bcb1e.jpg";